import React from "react";
// import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
// import { Button, Grid } from "@mui/material";
import ladyImg from "../../../assets/Images/lady.jpg";
// import CheckIcon from '@mui/icons-material/Check';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import ApartmentIcon from '@mui/icons-material/Apartment';
// import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
// import Person3Icon from '@mui/icons-material/Person3';
// import SecurityIcon from '@mui/icons-material/Security';
import MailIcon from '@mui/icons-material/Mail';
import PhoneForwardedIcon from '@mui/icons-material/PhoneForwarded';

function Aboutus() {
  // const navigate = useNavigate();
  return (
    <>
      <Top />
      <Left />
      
      <div className="rightContent">
        <h1 className="aboutHeing">About Resipro</h1>
        <div className="aboutUs" >
            <div className="aboutBoxImg" >
                <img src={ladyImg} className="borderRadius" alt="altimg"/>
            </div>
            <div className="aboutBox">
                <h1 className="panelHeading">Our idea of society management platform:</h1>
                <p className="bottSp">emerged from the many evident gaps that we observed when it comes to the security and management of gated communities. Having years of experience and expertise in the real estate industry, we have gained valuable insights into the challenges faced by residents, managers, and security personnel. </p>
                <p>Our state-of-the-art society management software comes with wide range of services and features enabling the residents to manage multiple society related activities all in one place. By leveraging our solution, you can efficiently manage your society while ensuring a secure and harmonious community living experience. Both residents and management can enjoy peace of mind knowing that their needs are met effectively.
                </p>
                
            </div> 
        </div>
        <div className="aboutBox aboutWtBox">
            <ul>
                <li>
                <span className="tikmark" ><CheckCircleIcon/></span>
                Are you finding it difficult to manage your society data such as resident names, email id’s, phone numbers, apartment numbers, amenities, service providers?
                </li>
                <li>
                <span className="tikmark" ><CheckCircleIcon/></span>
                Are you finding it difficult to keep a track of people visiting your society?
                </li>
                <li>
                <span className="tikmark" ><CheckCircleIcon/></span>
                Are you finding it tedious to track the maintenance dues from residents and issuing receipts?
                </li>
                <li>
                <span className="tikmark" ><CheckCircleIcon/></span>
                Are the residents not happy with issues not getting resolved on time in spite of reminders?
                </li>
                <li>
                <span className="tikmark" ><CheckCircleIcon/></span>
                Do the residents find it difficult to stay updated with the notices and other society related issues?
                </li>
            </ul>  
            <div className="supportBox">
              <h1 className="panelHeading">Customer Support</h1> 
              <div className="support">
                 <div className="supportIn">
                    {/* <h1 className="panelHeading">Technical Support</h1>  */}
                    <div>
                        <span><PhoneForwardedIcon/></span>
                        <span>+91 9850821242</span>
                    </div>
                    <div>
                        <span><MailIcon/></span>
                        <span>tanmay.samal@alptechsoftware.com</span>
                    </div>
                 </div>
                 <div className="supportIn">
                    {/* <h1 className="panelHeading">Customer Support</h1>  */}
                    <div>
                        <span><PhoneForwardedIcon/></span>
                        <span>+91 8263956984</span>
                    </div>
                    <div>
                        <span><MailIcon/></span>
                        <span>vikas.dhere@alptechsoftware.com</span>
                    </div>
                 </div>
              </div>  
            </div>
        </div>
      </div>
    </>
  );

}

export default Aboutus;
